import baseConfig from "./base";
import betaConfig from "./beta";
import prodConfig from "./prod";
import stagConfig from "./stag";

const env = process.env.REACT_APP_ENV || "dev";
const envConfig: Record<string, any> = {
  stag: stagConfig,
  beta: betaConfig,
  prod: prodConfig,
};

export default { ...baseConfig, ...(envConfig[env] || {}) };
